import { type FC } from 'react';
import { Text } from 'Text';

type Props = {
    caption: string;
    intro: string;
    id?: string;
    introClassName?: string;
};

// The caption, rule and intro shared by the key terms and Assigned Reading sections.
export const BandSectionHeading: FC<Props> = ({ caption, intro, id, introClassName }) => (
    <>
        {/* On a wrapper, because Text takes no id. */}
        <div id={id}>
            {/* mt-0 cancels the bootstrap_compat top margin on h2. */}
            <Text
                as="h2"
                className="mb-5 mt-0 text-center text-lg font-semibold leading-5 text-slate-grey sm:mb-6.25 sm:text-2xl sm:leading-8"
            >
                {caption}
            </Text>
        </div>
        <hr className="my-5 border-t border-slate-grey-200" />
        <Text
            as="p"
            className={`mx-auto mb-3.5 w-full text-center text-sm leading-5.5 text-slate-grey sm:mb-4.5 sm:w-10/12 sm:text-md sm:leading-7 ${introClassName ?? ''}`}
        >
            {intro}
        </Text>
    </>
);
